import clsx from "clsx";
import trim from "lodash/trim";
import React from "react";
import InstantFeedback from "web/react/components/instant-feedback/instant-feedback";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import { useClickTracker } from "web/react/hooks/use-click-tracker/use-click-tracker";
import { gettext } from "web/script/modules/django-i18n";
import { AccountLink } from "./account-links";
// eslint-disable-next-line css-modules/no-unused-class
import styles from "./account-links.module.css";

export default function SavedSearchLink({ url }: AccountLink): JSX.Element {
    const onClick = useClickTracker("nav", "clicked", trim(url as string, "/"));
    return (
        <div className={clsx(styles.glyph, "hidden-tablet")}>
            <InstantFeedback
                message={
                    // Search saved! You can manage it orcreate a new one from My searches.
                    gettext("instant_feedback.du")
                }
                area="saved-search"
                direction="bottom"
            >
                <a className={styles.icon} href={url} onClick={onClick}>
                    <div className={styles.iconLink}>
                        <SVGIcon name="searches-icon" />
                    </div>
                    <div className={styles.iconText}>
                        {
                            // My Searches
                            gettext("saved_searches.header_icon_text")
                        }
                    </div>
                </a>
            </InstantFeedback>
        </div>
    );
}
